module.exports = __webpack_public_path__ + "static/media/wrench.ed6e6c4e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/wrench.svg
// module id = 139
// module chunks = 0